module.exports = __webpack_public_path__ + "static/media/arrow-3.ba19cf35.png";